<template>
  <a-drawer
    title="编辑面标记"
    :width="470"
    placement="right"
    :closable="false"
    @close="handleCancel"
    :visible="visible"
  >
    <div>
      <a-form :form="form">
        <a-form-item label="名称" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-textarea
            v-decorator="['name']"
            placeholder="请输入面标记名称"
            auto-size
          />
        </a-form-item>
        <a-form-item label="颜色" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <div class="color-options">
            <div
              v-for="option in colorOptions"
              :key="option.key"
              class="color-circle"
              :class="{ 'color-circle--active': selectedColorKey === option.key }"
              :style="{ backgroundColor: option.hex }"
              @click="handleColorClick(option.key)"
            >
              <a-icon
                v-if="selectedColorKey === option.key"
                type="check"
                class="color-circle__check"
              />
            </div>
          </div>
        </a-form-item>
        <a-form-item label="分组" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-input
            v-decorator="['group']"
            placeholder="请输入分组名"
            auto-size
          />
          <div class="group-tags-wrapper" v-if="existingGroups && existingGroups.length">
            <a-tag
              v-for="group in existingGroups"
              :key="group"
              class="group-tag"
              @click="handleGroupTagClick(group)"
            >{{ group }}</a-tag>
          </div>
        </a-form-item>
        <a-form-item label="信息" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" v-if="polygon">
          <span class="polygon-info">
            {{ polygon.points ? polygon.points.length : 0 }} 个点
            <span v-if="polygon._area"> · {{ polygon._area }}</span>
          </span>
        </a-form-item>
      </a-form>

      <div
        :style="{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e8e8e8',
          padding: '10px 16px',
          textAlign: 'right',
          left: 0,
          background: '#fff',
          borderRadius: '0 0 4px 4px',
        }"
      >
        <a-button type="danger" class="delete-button" @click="handleDelete">删除</a-button>
        <a-button style="marginRight: 8px" @click="handleCancel">取消</a-button>
        <a-button @click="handleOk" type="primary">确定</a-button>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import { POLYGON_DEFAULT_COLOR_KEY, getPolygonColorOptions } from '@/utils/polygon-utils';

export default {
  props: {
    visible: Boolean,
    polygon: Object,
    existingGroups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'polygonModal' }),
      selectedColorKey: POLYGON_DEFAULT_COLOR_KEY,
      colorOptions: getPolygonColorOptions(),
    };
  },
  methods: {
    handleOk() {
      const formData = this.form.getFieldsValue();
      const result = {
        ...this.polygon,
        name: formData.name || '',
        colorKey: this.selectedColorKey,
        group: formData.group || '',
      };
      this.$emit('confirm', result);
      this.handleCancel();
    },
    handleCancel() {
      this.$emit('update:visible', false);
    },
    handleDelete() {
      this.handleCancel();
      this.$emit('delete', this.polygon);
    },
    handleColorClick(colorKey) {
      this.selectedColorKey = colorKey;
    },
    handleGroupTagClick(group) {
      this.form.setFieldsValue({ group });
    },
  },
  watch: {
    async visible(newVal) {
      if (newVal) {
        this.form.resetFields();
        this.selectedColorKey = POLYGON_DEFAULT_COLOR_KEY;

        await this.$nextTick();

        // 回显
        if (this.polygon) {
          this.selectedColorKey = this.polygon.colorKey || POLYGON_DEFAULT_COLOR_KEY;
          this.form.setFieldsValue({
            name: this.polygon.name || '',
            group: this.polygon.group || '',
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.color-options {
  display: flex;
  gap: 16px;
}

.color-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid transparent;
  transition: border-color 0.2s, transform 0.15s;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.color-circle:hover {
  transform: scale(1.1);
}

.color-circle--active {
  border-color: #333;
}

.color-circle__check {
  color: #ffffff;
  font-size: 18px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.delete-button {
  float: left;
}

.group-tags-wrapper {
  margin-top: 4px;
}

.group-tag {
  cursor: pointer;
  user-select: none;
}

.group-tag:hover {
  opacity: 0.8;
}

.polygon-info {
  color: #666666;
}
</style>
